import api from "../api/axios";

// ----- Cities CRUD -----

export const fetchCities = async () => {
  const response = await api.get("/cities");
  return response.data;
};

export const createCity = async (payload) => {
  const response = await api.post("/cities", payload);
  return response.data;
};

export const updateCity = async (id, payload) => {
  const response = await api.patch(`/cities/${id}`, payload);
  return response.data;
};

export const deleteCity = async (id) => {
  const response = await api.delete(`/cities/${id}`);
  return response.data;
};

// ----- Driver <-> City assignments -----

export const fetchDriverCities = async () => {
  const response = await api.get("/cities/driver-cities");
  return response.data;
};

export const createDriverCity = async (payload) => {
  const response = await api.post("/cities/driver-cities", payload);
  return response.data;
};

export const deleteDriverCity = async (id) => {
  const response = await api.delete(`/cities/driver-cities/${id}`);
  return response.data;
};

// ----- Driver options -----

export const fetchDriverOptions = async () => {
  const response = await api.get("/personnel/drivers");
  return response.data;
};
